import { connect } from 'react-redux';
import NewsCard from './NewsCard';


let mapStateToProps = (state) => {
  return {
    newsData: state.newsPage.newsData
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const NewsCardContainer = connect(mapStateToProps, mapDispatchToProps)(NewsCard);

export default NewsCardContainer;